import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FieldRow, FieldValue } from '@/components/layout/field-row'
import { TextInput } from '@/components/ui/text-input'
import { Typography } from '@/components/ui/typography'
import { Building } from '@/reducers/types'

import { OtherFormData } from './other-tab.constants'

interface ApartmentsIdEditProps {
  building: Building
  isAdmin: boolean
}

export const ApartmentsIdEdit = ({ building, isAdmin }: ApartmentsIdEditProps) => {
  const { t } = useTranslation(['organisation'])
  const {
    clearErrors,
    formState: { errors },
    setValue,
  } = useFormContext<OtherFormData>()
  const apartmentsId = useWatch<OtherFormData, 'apartmentsId'>({ name: 'apartmentsId' })
  const error = errors.apartmentsId?.message

  return (
    <FieldRow label={t('organisation:places.other.apartments.title')}>
      <FieldValue>
        {isAdmin ? (
          <>
            <TextInput
              error={error}
              helperText={error ? undefined : t('organisation:places.other.apartments.hint')}
              name="apartmentsId"
              placeholder={t('organisation:places.apartmentsId.placeholder')}
              size="small"
              value={apartmentsId}
              onChange={(event) => {
                clearErrors('apartmentsId')
                setValue('apartmentsId', event.target.value, { shouldDirty: true })
              }}
            />
            {building.apartmentsName && (
              <Typography size="text-small" color="black500">
                {building.apartmentsName}
              </Typography>
            )}
          </>
        ) : (
          <Typography size="text-small" color="black500">
            {t('organisation:places.other.apartments.adminOnly')}
          </Typography>
        )}
      </FieldValue>
    </FieldRow>
  )
}
